<form [formGroup]="UserForm" (ngSubmit)="saveUser(UserForm.value)">
  <div class="row margin-top-8" *ngIf="user.ID">
    <div class="col-md-2 label">{{ 'general.username' | translate }}:</div>
    <div class="col-md-4 value">
      {{user.UserName}}
    </div>
  </div>
  <div *ngIf="!user.ID" class="user-choice">
    <div class="row margin-top-8">
      <div class="col-md-2"></div>
      <div class="col-md-10 type-header">{{ 'general.type_of_user' | translate }}:</div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2"></div>
      <div class="col-md-1 label">{{ 'onboarding.admin' | translate }}:</div>
      <div class="col-md-1">
        <p-radioButton name="userView" value="admin_view" [(ngModel)]="userView"
                       [ngModelOptions]="{standalone: true}">
        </p-radioButton>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2"></div>
      <div class="col-md-1 label">{{ 'onboarding.technician' | translate }}:</div>
      <div class="col-md-1">
        <p-radioButton name="userView" value="technician_view" [(ngModel)]="userView"
                       [ngModelOptions]="{standalone: true}">
        </p-radioButton>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-2 label">*{{ 'general.email' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="text" pInputText formControlName="Email" placeholder="{{ 'general.email' | translate }}"
               (change)="searchUser($event)"/>
      </div>
    </div>
    <div class="col-md-2 label">{{ 'general.phone_number' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="text" pInputText formControlName="PhoneNumber"
               placeholder="{{ 'general.phone_number' | translate }}"/>
        <!--<p-inputMask formControlName="PhoneNumber" mask="+ 999 99 999-9999" placeholder="{{ 'general.phone_number' | translate }}"></p-inputMask>-->
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-2 label">*{{ 'general.firstname' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="text" pInputText placeholder="{{ 'general.firstname' | translate }}"
               formControlName="Name"/>
      </div>
    </div>
    <div class="col-md-2 label">*{{ 'general.surname' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="text" pInputText placeholder="{{ 'general.surname' | translate }}"
               formControlName="Surname"/>
      </div>
    </div>
  </div>

  <div class="row margin-top-8" *ngIf="showGDPRMarketingConsent == true">
    <div class="col-md-2 label">{{ 'bikeshop.modal.update_job_card.job_card.showgdprconsent' | translate }}:</div>
    <div class="col-md-10" style="display: flex; align-items: center;">
      <p-inputSwitch formControlName="UserGaveGDPRMarketingConsent"></p-inputSwitch>
      <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;
        ">
        {{
        "bikeshop.modal.update_job_card.job_card.showgdprconsent_info" | translate
        }}
      </small>
    </div>
  </div>

  <!--<div class="row margin-top-8">
    <div class="col-md-2 label">{{ 'general.date_of_birth' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-calendar"></i></span>
        <p-calendar formControlName="DateOfBirth" dateFormat="yy-mm-dd"
          placeholder="{{ 'general.date_of_birth' | translate }}" [monthNavigator]="true" [yearNavigator]="true"
          yearRange="1900:2030"></p-calendar>
      </div>
    </div>
    <div class="col-md-2 label">{{ 'general.gender' | translate }}:</div>
    <div class="col-md-4">
      <p-dropdown [options]="genders" class="full-width" formControlName="GenderID"
        placeholder="{{ 'general.select_a_gender' | translate }}">
      </p-dropdown>
    </div>
  </div>-->
  <div class="row margin-top-8" *ngIf="!user.ID">
    <div class="col-md-2 label">*{{ 'general.password' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="password" pInputText formControlName="Password"
               placeholder="{{ 'general.password' | translate }}"/>
      </div>
    </div>
    <div class="col-md-2 label">*{{ 'general.confirm_password' | translate }}:</div>
    <div class="col-md-4">
      <div class="p-inputgroup">
        <input type="password" pInputText formControlName="ConfirmPassword"
               placeholder="{{ 'general.confirm_password' | translate }}"/>
      </div>
    </div>
  </div>
  <div class="row margin-top-16">
    <div class="col-md-3">
      <button pButton type="button" class="p-button-raised full-width alternate"
              label="{{ 'bikeshop.modal.add_edit_user.user_form.unlink' | translate }}" (click)="unlinkUser()"
              *ngIf="user && user.ID && !cyclistView" [disabled]="busy"></button>
    </div>
    <div class="col-md-3">
      <button pButton type="button" class="p-button-raised full-width alternate"
              label="{{ 'bikeshop.modal.add_edit_user.user_form.technician_view' | translate }}"
              (click)="actionTechnician()"
              *ngIf="user.ID && !cyclistView" [disabled]="busy || isTechnician"></button>
    </div>
    <div class="col-md-3">
      <button pButton type="button" class="p-button-raised full-width alternate"
              label="{{ 'bikeshop.modal.add_edit_user.user_form.admin_view' | translate }}"
              (click)="actionTechnician()"
              *ngIf="user.ID && !cyclistView" [disabled]="busy || !isTechnician"></button>
    </div>
    <div class="col-md-3">
      <button pButton type="submit" class="p-button-raised full-width"
              label="{{user.ID ? ('bikeshop.modal.add_edit_user.user_form.update_user' | translate ) : ('bikeshop.modal.add_edit_user.user_form.create_user' | translate ) }}"
              [disabled]="!UserForm.valid || userExists || busy || (!user.ID && userView === null)"></button>
    </div>
  </div>
  <div class="row margin-top-8" *ngIf="isSuperUser">
    <div class="col-md-9"></div>
    <div class="col-md-3">
      <button pButton type="button" (click)="resetPassword.show($event)"
              class="p-button-raised full-width" label="Reset User Password"></button>
    </div>
    <p-overlayPanel #resetPassword [dismissable]="false" [showCloseIcon]="true">
      <ng-template pTemplate="content">
        <app-reset-password [user]="user" [component]="resetPassword"
                            [messageService]="messageService">
        </app-reset-password>
      </ng-template>
    </p-overlayPanel>

  </div>
  <div class="row">
    <div *ngIf="error" class="col-md-12 errormessage">{{errorMessage}}</div>
  </div>
  <div class="row">
    <div *ngIf="message" class="col-md-12 message" innerHTML={{message}}></div>
  </div>
</form>

<p-confirmDialog key="user_key" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
